<input
    #input
    type="checkbox"
    class="cdk-visually-hidden"
    [class.mdc-checkbox--selected]="checked"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    [attr.aria-checked]="indeterminate ? 'mixed' : null"
    [attr.name]="name"
    [attr.value]="value"
    [checked]="checked"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
    [id]="inputId"
    [required]="required"
    [tabIndex]="tabIndex"
    (blur)="_onBlur()"
    (click)="_onInputClick()"
    (change)="_onInteractionEvent($event)"
/>
<label [for]="inputId">
    <span class="icon" [class.selected]="checked || indeterminate">
        <dtm-ui-icon *ngIf="indeterminate" name="checkbox-indeterminate"></dtm-ui-icon>
        <dtm-ui-icon *ngIf="!indeterminate && !checked" name="checkbox-blank"></dtm-ui-icon>
        <dtm-ui-icon *ngIf="!indeterminate && checked" name="checkbox"></dtm-ui-icon>
    </span>
    <span class="label"><ng-content></ng-content></span>
    <span class="checkbox-field-hint"><ng-content select="[checkboxFieldHint]"></ng-content></span>
</label>
